import React from 'react';
import cx from 'classnames';

import CardsVariation from '@redturtle/iovisit-theme/components/Blocks/Listing/CardsTemplate/Cards';
import LinkCardVariation from '@redturtle/iovisit-theme/components/Blocks/Listing/LinkCard';

interface RelatedItemsProps {
  className?: string;
  background?: boolean;
  items: any[];
  title: string;
  bg_color?: string;
  variation?: string;
}

const RelatedItems = ({
  items = [],
  className,
  background = false,
  title,
  bg_color = 'primary',
  variation = 'cards',
}: RelatedItemsProps) => {
  return items?.length > 0 ? (
    <div className={cx('related-items', className)}>
      <div className="block listing">
        {variation === 'cards' ? (
          <CardsVariation
            show_block_bg={background}
            show_title={true}
            title={title}
            items={items}
            background_color={bg_color}
          />
        ) : (
          <>
            <LinkCardVariation
              show_block_bg={background}
              show_title={true}
              items={items}
              title={title}
              background_color={bg_color}
            />
          </>
        )}
      </div>
    </div>
  ) : null;
};

export default RelatedItems;
